import { render, staticRenderFns } from "./taskdetail.vue?vue&type=template&id=9d5a6d34&scoped=true"
import script from "./taskdetail.vue?vue&type=script&lang=js"
export * from "./taskdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5a6d34",
  null
  
)

export default component.exports